console.log('CUSTOM ADD TO CART JS LOADED');
(function () {
  const loadingTimers = new WeakMap();

  function resetButton(button) {
    if (!button) return;

    const timer = loadingTimers.get(button);

    if (timer) {
      clearTimeout(timer);
      loadingTimers.delete(button);
    }

    button.classList.remove(
      'custom-atc-loading',
      'custom-atc-success'
    );

    button.removeAttribute('aria-busy');

    if (button.dataset.customAtcOriginalHtml) {
      button.innerHTML = button.dataset.customAtcOriginalHtml;
      delete button.dataset.customAtcOriginalHtml;
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        !form ||
        !form.matches('form[data-product-form]')
      ) {
        return;
      }

      const button = form.querySelector('[data-product-atc]');
      const variant = form.querySelector('[data-variants]');

      if (!button) {
        return;
      }

      if (
        variant &&
        (
          !variant.value ||
          variant.value === 'not-selected' ||
          variant.value === 'unavailable'
        )
      ) {
        return;
      }

      if (button.classList.contains('custom-atc-loading')) {
        return;
      }

      button.dataset.customAtcOriginalHtml = button.innerHTML;

      button.classList.add('custom-atc-loading');
      button.setAttribute('aria-busy', 'true');

      const timer = setTimeout(function () {
        resetButton(button);
      }, 15000);

      loadingTimers.set(button, timer);
    },
    true
  );

  window.addEventListener('cartcount:update', function () {

    document
      .querySelectorAll(
        '.product-form--atc-button.custom-atc-loading'
      )
      .forEach(function (button) {

        const timer = loadingTimers.get(button);

        if (timer) {
          clearTimeout(timer);
          loadingTimers.delete(button);
        }

        button.classList.remove('custom-atc-loading');
        button.classList.add('custom-atc-success');

        button.removeAttribute('aria-busy');

        button.innerHTML = '✓ Item Added to Cart';

        setTimeout(function () {
          resetButton(button);
        }, 2000);
      });
  });
})();